var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.333,
    height: 16,
    viewBox: "0 0 21.333 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "envelope",
    d: "M2,64A2,2,0,0,0,.8,67.6l9.067,6.8a1.338,1.338,0,0,0,1.6,0l9.067-6.8a2,2,0,0,0-1.2-3.6ZM0,68.667v8.667A2.669,2.669,0,0,0,2.667,80h16a2.669,2.669,0,0,0,2.667-2.667V68.667l-9.067,6.8a2.663,2.663,0,0,1-3.2,0Z",
    transform: "translate(0 -64)",
    fill: "#003087"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.e36574b14151847c3bb5c63f157c7680.svg";
export { ForwardRef as ReactComponent };